import React, { useCallback } from 'react';
import type { ICellRendererParams } from '@ag-grid-community/core';
import { Button, Paper } from '@material-ui/core';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';

import SquareActionButton from 'src/common-ui/components/Buttons/SquareActionButton';
import { PlanMetadata } from 'src/state/scope/codecs/PlanMetadata';
import { Overlay } from 'src/common-ui';
import TemplateModalWithButton from 'src/components/TemplateModalWithButton/TemplateModalWithButton';

interface DeleteIconRenderProps extends ICellRendererParams {
  data: PlanMetadata;
  onClick: (data: PlanMetadata) => void;
  deletePlanLoading: boolean;
}

export default function DeleteIconRenderer(props: DeleteIconRenderProps) {
  const { onClick, data, deletePlanLoading } = props;

  const handleSubmit = useCallback(() => {
    onClick(data);
  }, [onClick, data]);

  return (
    <TemplateModalWithButton
      title="Delete Plan"
      buttonComponent={
        <Button
          style={{ backgroundColor: '#db2828', padding: '8px', minWidth: 'unset' }}
          variant="contained"
        >
          <DeleteOutlinedIcon style={{ color: 'white' }} />
        </Button>
      }
      showSubmit
      onSubmit={handleSubmit}
      onCancel={() => {}}
      paperClassName="import-version-modal"
      customSubmitComponent={({ submit, cancel }) => (
        <>
          <SquareActionButton text="Cancel" type="secondary" onClick={cancel} />
          <SquareActionButton
            text="Delete"
            data-qa="delete-plan-btn-delete"
            onClick={submit}
          />
        </>
      )}
    >
      <div data-qa="delete-plan-modal">
        {deletePlanLoading && <Overlay type="loading" visible fitParent />}
        <Paper variant="outlined" style={{ padding: '16px' }}>
          This action will delete the plan named "<strong>{data.name}</strong>". This <em>cannot</em>{' '}
          be undone. Do you wish to proceed?
        </Paper>
      </div>
    </TemplateModalWithButton>
  );
}
